module.exports = __webpack_public_path__ + "img/roof-material-s8.82e58eeb.svg";